import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";

interface AccountLinkProps {
  link: string;
  title: string;
  icon?: React.ReactNode;
}

const AccountLink: FC<AccountLinkProps> = ({ link, title, icon }) => {
  const location = useLocation();
  const isActive = location.pathname === link;

  return (
    <Link
      to={link}
      className={`account-link-tile ${isActive ? "active-link" : ""}`}
    >
      <div className="tile-icon">{icon}</div>
      <div className="tile-title">{title}</div>
    </Link>
  );
};

export default AccountLink;
